// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "li[data-v-595e57e2]:hover {\n  background-color: #c8cfdb;\n}\nli a[data-v-595e57e2] {\n  display: block;\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-weight: 600;\n  font-size: .75rem;\n  color: #3c5174;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
